export const FETCHING_INVOICES_LIST = '@@toyota/FETCHING_INVOICES_LIST';
export const FETCHED_INVOICES_LIST = '@@toyota/FETCHED_INVOICES_LIST';
export const FETCHED_INVOICES_LIST_FAILED = '@@toyota/FETCHED_INVOICES_LIST_FAILED';

export const FETCHING_INVOICE_ITEM = '@@toyota/FETCHING_INVOICE_ITEM';
export const FETCHED_INVOICE_ITEM = '@@toyota/FETCHED_INVOICE_ITEM';
export const FETCHED_INVOICE_ITEM_FAILED = '@@toyota/FETCHED_INVOICE_ITEM_FAILED';

export const FETCHING_INVOICE_COMBOS = '@@toyota/FETCHING_INVOICE_COMBOS';
export const FETCHED_INVOICE_COMBOS = '@@toyota/FETCHED_INVOICE_COMBOS';
export const FETCHED_INVOICE_COMBOS_FAILED = '@@toyota/FETCHED_INVOICE_COMBOS_FAILED';

export const FETCHING_INVOICES_DOWNLOAD_LIST = '@@toyota/FETCHING_INVOICES_DOWNLOAD_LIST';
export const FETCHED_INVOICES_DOWNLOAD_LIST = '@@toyota/FETCHED_INVOICES_DOWNLOAD_LIST';
export const FETCHED_INVOICES_DOWNLOAD_LIST_FAILED = '@@toyota/FETCHED_INVOICES_DOWNLOAD_LIST_FAILED';

export const CLEAR_INVOICE_LIST = '@@toyota/ CLEAR_INVOICE_LIST';
export const CLEAR_INVOICES_DOWNLOAD_LIST = '@@toyota/ CLEAR_INVOICES_DOWNLOAD_LIST';

